import TopBar from "../Topbar/Topbar";
import Navbar from "./Navbar";
import OrganizationSchema from "../components/OrganizationSchema";
import WebSiteSchema from "../components/WebSiteSchema";
import "./Header.css";

// Every page renders <Header/> as a sibling of its content (not a
// wrapper), so there's no single React tree to attach a "main
// content" id to from here. Instead, the skip link finds whatever
// element immediately follows .site-header in the DOM at click time
// and focuses/scrolls to it directly — works for every page without
// needing each one to add a matching id.
function skipToMainContent(e) {
  e.preventDefault();
  const header = document.querySelector(".site-header");
  const target = header?.nextElementSibling;
  if (!target) return;
  if (!target.hasAttribute("tabindex")) target.setAttribute("tabindex", "-1");
  target.focus();
  target.scrollIntoView();
}

export default function Header() {
  return (
    <>
      <OrganizationSchema />
      <WebSiteSchema />

      <a href="#main-content" className="skip-link" onClick={skipToMainContent}>
        Skip to main content
      </a>


      <header className="site-header">

            <TopBar />

            <Navbar />

        </header>
    </>
  );
}